export default "__VITE_ASSET__Dal8qOKV__"